import { Component } from '@angular/core';

@Component({
    template: `<customize-page></customize-page>`,
  standalone: false
})
export class CustomizeHomepageComponent { }
